import { render, staticRenderFns } from "./person_pwd_set.vue?vue&type=template&id=018badd8&scoped=true"
import script from "./person_pwd_set.vue?vue&type=script&lang=js"
export * from "./person_pwd_set.vue?vue&type=script&lang=js"
import style0 from "./person_pwd_set.vue?vue&type=style&index=0&id=018badd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018badd8",
  null
  
)

export default component.exports